module.exports = __webpack_public_path__ + "img/penta5ex_icon.c9f2ec35.png";